import React, { useState, useEffect } from 'react'
import { GridWrapper, ItemsWrapper, GridTitle, ShowMoreCta } from './style'
import TripItem from './TripItem'
import { getTranslations } from '../../../../utils'

const TripsGrid = ({
  id,
  items,
  title,
  isLessThanLaptop,
  language,
  organizationSlug,
  itemsPerRow,
  itemsPerPage,
  isChatMode,
}) => {
  const [currentIsLessThanLaptop, setIsCurrentIsLessThanLaptop] =
    useState(false)
  const [itemsToShow, setItemsToShow] = useState(0)
  const [gridId, setGridId] = useState(null)

  useEffect(() => {
    if (isLessThanLaptop) setIsCurrentIsLessThanLaptop(isLessThanLaptop)
  }, [isLessThanLaptop])

  useEffect(() => {
    if (id !== gridId) {
      setGridId(id)
      setItemsToShow(itemsPerPage)
    }
  }, [id])

  const getItems = () => {
    const slicedItemsToShow = items.slice(0, itemsToShow)

    let itemsToReturn = slicedItemsToShow?.map((item, i) => {
      return (
        <TripItem
          key={item.url + i}
          isLessThanLaptop={currentIsLessThanLaptop}
          item={item}
          language={language}
          organizationSlug={organizationSlug}
          itemsPerRow={itemsPerRow}
        />
      )
    })

    return itemsToReturn
  }

  return (
    <>
      <GridWrapper id='grid-wrapper-trip'>
        {getItems().length ? (
          <>
            {title ? (
              <GridTitle isChatMode={isChatMode}>{title}</GridTitle>
            ) : null}
            <ItemsWrapper>{getItems()}</ItemsWrapper>
          </>
        ) : null}
        {itemsToShow < items.length ? (
          <ShowMoreCta
            onClick={() => {
              setItemsToShow(itemsToShow + itemsPerPage)
            }}
          >
            {getTranslations('show_more')}
          </ShowMoreCta>
        ) : null}
      </GridWrapper>
    </>
  )
}

export default TripsGrid
